<template>
  <div id="ApplicationForm">
    <AgreementsDialog
      @close="isAgreementsDialogOpen = false"
      v-if="isAgreementsDialogOpen"
    />
    <ValidationObserver v-slot="{ invalid, errors }" ref="validform">
      <form @submit.prevent="application()">
        <main class="">
          <div class="section top">
            <div class="top__logo">
              <h3><strong>오늘의 식당</strong></h3>
            </div>
          </div>
          <div class="section form-group">
            <div class="description">
              <h3 class="title">
                나의 단골가게<br /><strong>{{
                  applicationData.visitStoreName
                }}</strong>
              </h3>
            </div>
            <div class="promotion">
              <img
                src="../../../assets/images/todaystore/todaystore-temporary-halt.png"
              />
            </div>
            <div class="sub-description">
              <p class="sub-description__top">
                응원의 한마디와 경품 당첨을 위한<br />휴대폰 번호를 남겨주세요!
              </p>
            </div>
            <div class="field-group name flex">
              <FormInput
                type="text"
                name="name"
                style="flex: auto"
                v-model="applicationData.name"
                rules="required"
                placeholder="이름을 입력해주세요"
              />
              <p
                v-if="errors.name != null && errors.name[0] != null"
                class="error-text"
              >
                {{ errors.name[0] }}
              </p>
            </div>
            <div class="field-group phone flex">
              <FormInput
                type="tel"
                name="phone"
                style="flex: auto"
                v-model="applicationData.phone"
                rules="required|numeric|phone"
                placeholder="휴대폰 번호를 입력해주세요"
              />
              <p
                v-if="errors.phone != null && errors.phone[0] != null"
                class="error-text"
              >
                {{ errors.phone[0] }}
              </p>
            </div>
            <div class="field-group review flex">
              <textarea-autosize
                placeholder="*선택 응원의 한마디를 입력해주세요(최소 10자)"
                ref="textarea"
                name="review"
                rows="5"
                v-model="applicationData.visitReview"
              />
              <p
                v-if="
                  errors.visitReview != null && errors.visitReview[0] != null
                "
                class="error-text"
              >
                {{ errors.visitReview[0] }}
              </p>
            </div>
            <div class="field-group image flex">
              <uploader
                v-model="applicationData.fileList"
                :autoUpload="false"
                name="uploadImage"
                title="*선택 사진 첨부하기"
              ></uploader>
            </div>
            <div class="field-group agree-wrapper">
              <div class="img">
                <img
                  @click="isAgreed = !isAgreed"
                  v-if="isAgreed == true"
                  src="../../../assets/images/etc-checkbox-dn.png"
                />
                <img
                  @click="isAgreed = !isAgreed"
                  v-else
                  src="../../../assets/images/etc-checkbox.png"
                />
              </div>
              <div class="agreement" @click="isAgreementsDialogOpen = true">
                <p class="agreement__text">개인정보 이용&#183;제공 동의</p>
              </div>
            </div>
            <div class="sub-description">
              <p class="sub-description__bottom">
                *당첨자 발표 및 연락은 ‘오늘의 식당‘ 카카오채널을 통해
                이루어지며, 카카오톡 채널 추가까지 완료해야 정상 응모됩니다.
              </p>
            </div>
          </div>
          <div>
            <button
              type="submit"
              :disabled="invalid || isInProgress"
              class="button complete-button"
            >
              플친 추가하고 응모 완료하기!
              <v-progress-circular
                style="padding-left: 15px"
                size="24"
                v-if="isInProgress"
                indeterminate
                color="primary"
              />
            </button>
          </div>
        </main>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import applicationApi from '@/api/todaystore/applicationApi'
import storeApi from '@/api/todaystore/storeApi'
import FormInput from '@/components/form/FormInput'
import ChannelService from '@/service/channeltalk/ChannelService'
import AgreementsDialog from '@/components/modal/AgreementsDialog'
import Uploader from 'vux-uploader-component'

const plusFriendUrl = 'http://pf.kakao.com/_bXfhK'

export default {
  name: 'ApplicationForm',
  components: {
    FormInput,
    Uploader,
    AgreementsDialog,
  },
  data() {
    return {
      applicationData: {
        name: null,
        phone: null,
        visitStoreName: null,
        visitReview: null,
        fileList: [],
      },
      isAgreed: false,
      isAgreementsDialogOpen: false,
      isInProgress: false,
    }
  },
  async created() {
    document.title = '오늘의 식당'
    let data = await storeApi.getStore(this.$route.query['utm_source'])
    this.applicationData.visitStoreName = data['data'][0]['store_name']
  },
  mounted() {
    ChannelService.shutdown()
  },
  methods: {
    async application() {
      if (this.isAgreed === false) {
        alert('"경품 응모를 위한 개인정보 이용 제공 동의" 항목을 선택해주세요.')
        return
      }
      if (
        this.isInProgress === true ||
        this.$refs.validform.flags.invalid === true
      ) {
        return
      }
      this.isInProgress = true
      try {
        const formData = new FormData()
        formData.append('name', this.applicationData.name)
        formData.append('phone', this.applicationData.phone)
        formData.append('visit_store_name', this.applicationData.visitStoreName)
        formData.append('visit_review', this.applicationData.visitReview)
        for (let prop in this.applicationData.fileList) {
          formData.append(
            'visit_image_' + prop,
            this.applicationData.fileList[prop].blob
          )
        }
        let { data } = await applicationApi.postApplication(formData)
        if (data.is_duplicate_application) {
          alert('이미 응모 완료되었습니다.')
        } else {
          alert('플친 추가까지 완료하셔야, 정상 응모처리됩니다. 감사합니다.')
        }
        window.location = plusFriendUrl
      } catch (e) {
        alert('문제가 발생했습니다. 문제가 지속될 시 고객센터로 문의주세요.')
      } finally {
        this.isInProgress = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
#ApplicationForm {
  h1,
  h2,
  h3,
  h4,
  h5 {
    font-weight: 300;
  }
  textarea {
    border-radius: 4px;
    border: solid 1px #d7e1ea;
    background-color: #ffffff;
    font-size: 15px;
    font-weight: 300;
    padding-left: 10px;
    width: 100%;
  }
  .section {
    padding-left: 0;
    padding-right: 0;
  }
  .section.top {
    padding-left: 0;
    padding-right: 0;
  }
  .section.form-group {
    .field-group:not(.image) {
      padding-left: 3.2%;
      padding-right: 3.2%;
    }
    .field-group.phone {
      margin-top: 2.2%;
    }
    h3.title {
      font-size: 20px;
      text-align: center;
      line-height: 29px;
    }
    h3 strong {
      font-size: 22px;
    }
    .promotion img {
      max-width: 100%;
    }
    .image {
      font-size: 15px;
      font-weight: 300;
      margin-left: 3.2%;
      margin-right: 3.2%;
      border-radius: 4px;
      border: solid 1px #d7e1ea;
    }
    .description {
      margin-top: 3%;
      margin-bottom: 4%;
    }
    .sub-description {
      padding-left: 3.2%;
      padding-right: 3.2%;
    }
    .sub-description__top {
      text-align: center;
      font-size: 17px;
      margin: 3% 0;
      line-height: 23px;
    }
    .sub-description__bottom {
      font-size: 15px;
      margin: 3% 0;
      color: #333333;
      font-weight: 600;
    }
    textarea {
      font-family: NanumSquare, sans-serif;
    }
    textarea::-webkit-input-placeholder {
      padding-top: 10px;
    }
    .vux-uploader {
      width: 100%;
      padding: 10px;
    }
    .vux-uploader .vux-uploader_hd .vux-uploader_title {
      color: #808080 !important;
    }
    .agree-wrapper {
      display: flex;
      margin-top: 5%;
    }
    .agree-wrapper img {
      position: relative;
      bottom: 4px;
    }
    .agreement {
      margin-left: 1%;
    }
    .agreement__text {
      text-decoration: underline;
    }
  }
  .top__logo {
    background-color: #352921;
    min-height: 50px;
    width: 100%;
    display: table;
    h3 {
      color: white;
      text-align: center;
      display: table-cell;
      vertical-align: middle;
    }
  }
  .button.button {
    z-index: 0 !important;
    position: relative !important;
    color: #352921;
    min-height: 60px !important;
    font-weight: 700 !important;
  }
  button.complete-button:disabled {
    background-color: #e1e9f3 !important;
    color: #9aa4b3 !important;
  }
  button.complete-button {
    background-color: #ffe500 !important;
    color: #352921 !important;
  }
}
</style>
